/*

  Validation of Quality Seal Portal

*/

import qualitySealPortal from "./quality-seal-portal";

const qualitySealPortalValidation = {

    setValidation: function (context, foreignCaller = false) {
        let actualContext

        if (foreignCaller) {
            actualContext = $(context[0])
        } else {
            actualContext = $(this)
        }

        // Init variables
        let groupLocal      = $(actualContext).parent();
        let overlayLocal    = $(groupLocal).parent();
        let contactLocal    = $(groupLocal).find('.c-quality-seal-portal__input--required');
        let isConservation  = $(actualContext).attr('name') === 'tx_psrqualitysealportal_conservationunit[conservate]';
        let elementsSource

        if (!isConservation) {
            elementsSource = $(actualContext).parent().parent().find(".c-quality-seal-portal__radio");
        } else {
            elementsSource = $(overlayLocal).closest(".c-quality-seal-portal__row.row").find("input[name='tx_psrqualitysealportal_conservationunit[contactMarketing]']");
        }

        let contactSource = $(elementsSource[0]).parent().parent().find('.c-quality-seal-portal__input--required');
        let requireContactConservation = false;

        qualitySealPortalValidation.contactConservation = null;
        // Check isConservation
        if (isConservation) {
            $(overlayLocal).find('.c-quality-seal-portal__radio').each(function () {
                if ($(this).val() === "true" && $(this).prop('checked')) {
                    if (!qualitySealPortal.initalData.isNewUnit
                        && qualitySealPortal.initalData.checkedSinceLastEdit === 1
                        && qualitySealPortal.initalData.initalConservateState !== 1
                    ) {
                        $(contactLocal).removeClass('c-quality-seal-portal__input--hidden');
                    }
                    requireContactConservation = true;
                }
            })
            qualitySealPortalValidation.contactConservation = contactLocal;
        } else {
            qualitySealPortalValidation.contactConservation = $(overlayLocal).closest(".c-quality-seal-portal__row.row").find("input[name='tx_psrqualitysealportal_conservationunit[contactConservation]']");
            $(qualitySealPortalValidation.contactConservation).parent().parent().find(".c-quality-seal-portal__radio").each(function () {
                if ($(this).val() === "true" && $(this).prop('checked')) {
                    requireContactConservation = true;
                }
            });
        }

        let requireContactSourceByRadio = false;
        $(elementsSource).parent().parent().find(".c-quality-seal-portal__radio").each(function () {
            if ($(this).val() === "true" && $(this).prop('checked')) {
                requireContactSourceByRadio = true;
            }
        });

        if (requireContactConservation && !requireContactSourceByRadio) {
            removeProperties(contactSource)
            requireContactConservationElement(qualitySealPortalValidation.contactConservation);
            if ($(qualitySealPortalValidation.contactConservation).val().trim().length >= 3) {
                removeProperties(qualitySealPortalValidation.contactConservation);
            } else {
                addProperties(qualitySealPortalValidation.contactConservation);
            }
            if ($(contactSource).val().trim().length >= 3 || $(contactSource).val().trim().length === 0) {
                removeProperties(contactSource);
            } else {
                addProperties(contactSource);
            }
        } else if (requireContactConservation && requireContactSourceByRadio) {
            $(contactSource).attr('required', 'required')
            requireContactConservationElement(qualitySealPortalValidation.contactConservation);
            if ($(contactSource).val().trim().length >= 3 || $(contactSource).val().trim().length === 0) {
                removeProperties(contactSource);
            } else {
                addProperties(contactSource);
            }
            if ($(qualitySealPortalValidation.contactConservation).val().trim().length >= 3) {
                removeProperties(qualitySealPortalValidation.contactConservation);
            } else {
                addProperties(qualitySealPortalValidation.contactConservation);
            }
        } else if (!requireContactConservation && requireContactSourceByRadio) {
            $(contactSource).attr('required', 'required')
            if ($(contactSource).val().trim().length >= 3) {
                removeProperties(contactSource);
            } else {
                addProperties(contactSource);
            }
            removeProperties(qualitySealPortalValidation.contactConservation);
        } else {
            removeProperties(contactSource);
            removeProperties(qualitySealPortalValidation.contactConservation);
        }

        function addProperties(element) {
            if (!$(element).hasClass('not-validated')) {
                $(element).addClass('not-validated')
            }
        }
        function removeProperties(element) {
            $(element).removeAttr('required');
            $(element).removeClass('not-validated');
        }

        function requireContactConservationElement(element) {
            if (
                qualitySealPortal.initalData.isNewUnit
                || (
                    !qualitySealPortal.initalData.isNewUnit
                    && qualitySealPortal.initalData.checkedSinceLastEdit === 1
                    && qualitySealPortal.initalData.initalConservateState !== 1
                )
            ) {
                $(element).attr('required', 'required')
            }
        }
    },

    validateForm: function () {
        let contactValidation = true

        $(qualitySealPortal.form.find('.c-quality-seal-portal__input--validation')).each(function () {
            if ($(this).hasClass('not-validated')) {
                contactValidation = false
            }
        });

        if (
            contactValidation
            && (
                qualitySealPortal.form.find('.c-quality-seal-portal__radio--conservate:checked').val() === 'true' ||
                qualitySealPortal.form.find('.c-quality-seal-portal__checkbox--for-patrons').is(':checked') ||
                qualitySealPortal.form.find('.c-quality-seal-portal__checkbox--commercial').is(':checked') ||
                qualitySealPortal.form.find('.c-quality-seal-portal__radio--marketing:checked').val() === 'true'
            )
        ) {

            qualitySealPortal.form.slideUp(300);
            return true;

        } else {
            if (!contactValidation) {
                let backup = qualitySealPortal.dropdown;
                $(qualitySealPortal.form.find('.c-quality-seal-portal__input--validation')).each(function () {
                    if ($(this).hasClass('not-validated')) {
                        qualitySealPortal.dropdown = $(this).closest('.c-quality-seal-portal__dropdown');
                        qualitySealPortal.showDropdown();
                    }
                });
                qualitySealPortal.dropdown = backup;
            }

            qualitySealPortal.form.find('.c-quality-seal-portal__message--error').addClass('c-quality-seal-portal__message--active');
            return false;
        }
    }
}

export default qualitySealPortalValidation
